<app-gps-uploader [mediaForm]="mediaBlockService.mediaForm!" [contentType]="mediaBlockService.contentType!" />

<div class="track-slope u-fade-slide-in" [style.paddingRight.px]="elevationScaleWidth">
    <h3>{{ 'gps_uploader.track_profile' | translate }}</h3>
    <kin-icon name="gps_stroke" [color]="colorService.neutral500()" />
    <div class="hoverable-section" #hoverableSection (mousemove)="moveBar($event)"
        (mouseleave)="barPosition.set(null)">
        @if (mediaBlockService.hasGps() && barPosition() !== null) {
        <span class="syncro-bar" [style.left.px]="barPosition()" [style.height.px]="trackHeight()"></span>
        }
        <app-syncro-editor-slope-visualizer [showElevationScale]="true" [showDistanceScale]="true" />
    </div>
</div>